<template>
    <div>
        <div class="title" :style="getTitleStyle()">
            {{ obj.photo_classify_line_little_params.title }}
        </div>
        <div class="list-box" :style="getListBoxStyle()">
            <div v-for="(item, index) in 5" class="item" :key="index" :style="getItemStyle()">
                <div :style="getItemIconStyle()" class="icon"></div>
                <span>名称</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "PhotoClassifyLineLittleView",
    props: ['obj'],
    data() {
        return {
        }
    },
    methods: {
        getTitleStyle() {
            return 'margin-left: ' + this.obj.photo_classify_line_little_params.margin + 'px;';
        },
        getListBoxStyle() {
            return 'padding-left: ' + this.obj.photo_classify_line_little_params.margin + 'px;' +
                'padding-bottom: ' + this.obj.photo_classify_line_little_params.margin + 'px;' +
                'gap:' + this.obj.photo_classify_line_little_params.between_space + 'px;';
        },
        getItemStyle() {
            return 'border-width:' + this.obj.photo_classify_line_little_params.border_width + "px;" +
                "border-radius:" + this.obj.photo_classify_line_little_params.corner_radius + "px;" +
                "margin-right:" + this.obj.photo_classify_line_little_params.between_space + "px;" +
                "padding:" + this.obj.photo_classify_line_little_params.item_padding + "px " + this.obj.photo_classify_line_little_params.item_padding + "px;" +
                "border-color:" + this.obj.photo_classify_line_little_params.border_color + ";"
        },
        getItemIconStyle() {
            return 'width:' + this.obj.photo_classify_line_little_params.icon_width + "px;" +
                'height:' + this.obj.photo_classify_line_little_params.icon_height + "px;"
        }
    }


}
</script>

<style scoped lang="less">
.title {
    color: black;
    font-size: medium;
    line-height: 40px;
}

.list-box {
    overflow-x: hidden;
    overflow-y: hidden;
    white-space: nowrap;
    display: flex;

    .item {
        display: inline-block;
        text-align: center;
        font-size: small;
        box-sizing: border-box;
        border-style: solid;

        .icon {
            background-color: #d8d7d7;
            margin-bottom: 5px;
            border-radius: 50%;
        }
    }
}
</style>